import {IdName} from "../index";
import {SPINNER} from "../constants";

export enum LanguageId {
    Norwegian = 1,
    Danish = 38,
    Dutch = 40,
    English = 42,
    Finnish = 48,
    German = 53,
    Swedish = 154,
}

export type TLanguageKey = 'nb' | 'nl' | 'en' | 'fi' | 'da'| 'de' | 'sv';

// `id` is the language id used in `getlanguages` and `getsyncfields` API.
// `key` concedes with Navigator.languages
export interface ILanguage extends IdName {
    key: TLanguageKey
    languageKey?: string
    flag?: string
    flagCode?: string
}

export type ILanguageObject = {
    [key in TLanguageKey]?: string;
};

export const AvailableLanguages: ILanguage[] = [{
    id: LanguageId.Norwegian,
    key: 'nb',
    name: 'Norsk',
    flagCode: 'no',
}, {
    id: LanguageId.Dutch,
    key: 'nl',
    name: 'Dutch',
    flagCode: 'nl',
}, {
    id: LanguageId.English,
    key: 'en',
    languageKey: 'en-gb',
    name: 'English',
    flagCode: 'gb',
}, {
    id: LanguageId.Finnish,
    key: 'fi',
    name: 'Finnish',
    flagCode: 'fi',
}, {
    id: LanguageId.Danish,
    key: 'da',
    name: 'Danish',
    flagCode: 'dk',
}, {
    id: LanguageId.German,
    key: 'de',
    name: 'German',
    flagCode: 'de',
}, {
    id: LanguageId.Swedish,
    key: 'sv',
    name: 'Swedish',
    flagCode: 'se',
}]

export const Delimiter: string = '|'

export const COPYING_MESSAGE = `((copying|td)) ${SPINNER}`;
export const CREATING_MESSAGE = `((creating|td)) ${SPINNER}`;
export const DELETING_MESSAGE = `((deleting|td)) ${SPINNER}`;
export const ERROR_MESSAGE = `whooops something went wrong`;
export const LOGGIN_IN_MESSAGE = `((logging in|td)) ${SPINNER}`;
export const MOVING_MESSAGE = `((moving|td)) ${SPINNER}`;
export const PLEASE_WAIT_MESSAGE = `((Please wait|td)) ${SPINNER}`;
export const REDIRECTING_MESSAGE = `((redirecting|td)) ${SPINNER}`;
export const REMOVING_MESSAGE = `((removing|td)) ${SPINNER}`;
export const REQUEST_MESSAGE = `((loading data|td)) ${SPINNER}`;
export const RESTORING_MESSAGE = `((restoring|td)) ${SPINNER}`;
export const UPDATING_MESSAGE = `((updating|td)) ${SPINNER}`;
export const UPLOADING_MESSAGE = `((uploading|td)) ${SPINNER}`;
export const VALIDATING_MESSAGE = `((validating|td)) ${SPINNER}`;
/** Combobox/v2 empty prepared list — same chrome as loading, without spinner. */
export const NO_DATA_MESSAGE = `((no data|td))`;

export namespace nsSearch {
    export const MessageInitial = `type search key words`;
    export const MessageLoading = `((searching|td)) ${SPINNER}`;
    export const MessageNoResult = `no search result`;
}

export const EMPTY_STRING = '[((empty string))]';
export const NO_COMMENT = '[((no comment))]';
